import { translate } from '../services/i18n';

export const tagPromotionPrice = (hidePrice) => {
  if (hidePrice)
    return translate('CHECKOUT.STEP_ONE.PROMOTION_PRICE');
};